import React from "react";
import PropTypes from "prop-types";
import PostCard from "../PostCard";
import AdCard from "../AdCard";
import Transition from "react-transition-group/Transition";

const getPostWithImages = (post, getPostImages) => {
  const postImages = getPostImages(post);
  post.images = postImages.images;
  post.coverImageIndex = postImages.coverImageIndex;
  return post;
};

function CaseCardList({ posts, getPostImages }) {
  return (
    <div className="cards-list">
      {posts.map(post => {
        return (
          <Transition
            timeout={{
              enter: 100,
              exit: 500,
            }}
            key={post._id}
            in={!post.deleted && !post.isHidden}
            unmountOnExit={true}
          >
            {status =>
              !post.sponsered ? (
                <PostCard post={getPostWithImages(post, getPostImages)} animationClass={`post-${status}`} />
              ) : (
                <AdCard ad={post} />
              )
            }
          </Transition>
        );
      })}
    </div>
  );
}

CaseCardList.propTypes = {
  posts: PropTypes.array.isRequired,
  getPostImages: PropTypes.func.isRequired,
};

export default CaseCardList;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/CaseCardList/index.js